
<div [ngClass]="showlogo ? '':'tc-article-container'">
  <div *ngIf="showlogo" class="bgc-fasb-blue font-white pb-4rem">
    <div  class="height-4rem">
      <img alt="logo" [src]="logo" class="icon-fasb-logo pt-1">
    </div>
  </div>
  <p *ngIf="showActionBtns" class="tc-article font-size-10pt">
    In order to access the FASB Codification website, you need to agree to the latest terms and conditions.
  </p>
  <p *ngIf="showActionBtns" class="tc-article font-size-10pt">
    Please <strong>read these terms and conditions carefully</strong> and then accept the agreement.
  </p>
  <article id="printArticle" class="tc-article article-font print-all-content" [innerHTML]="body"></article>
  <div *ngIf="showActionBtns">
    <p class="tc-article"><span><strong><span style="font-size:10.0pt">TO ACCEPT THESE TERMS AND CONDITIONS AND ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND THE SAME, PLEASE CLICK THE ‘I ACCEPT” BUTTON.</span></strong></span></p>
    <div class="flex-display justify-content-center mb-1">
      <button mat-button class="print-button flex-display align-items-center" (click)="printPage()" (keyup.enter)="printPage()" tabindex="0">
        <img src="../../../../assets/icons/Print.svg" alt=""> &nbsp;
        <span class="print-button-text">
          Print this page
        </span>
      </button>
    </div>
    <div class="flex-display justify-content-center mb-1">
      <p tabindex="0">
        Do you agree with these terms and conditions?
      </p>
    </div>
    <div class="tc-acction-btns">
      <button mat-button class="btn-secondary " (click)="doNotAccept()" (keyup.enter)="doNotAccept()" tabindex="0">I DO NOT ACCEPT</button> &nbsp;
      <button mat-button class="btn-primary " (click)="accept()" (keyup.enter)="accept()" tabindex="0">I ACCEPT</button>
    </div>
  </div>

</div>
